import { render, staticRenderFns } from "./StaticInfo.vue?vue&type=template&id=98c06e2c&lang=pug"
import script from "./StaticInfo.vue?vue&type=script&lang=js"
export * from "./StaticInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports